<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createProducto"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mFeedProductsContentModalCreate.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <AtomInputPrimary
          v-model="producto.producto.nombre"
          :inputError="$v.producto.producto.nombre.$error"
          :label="$t('mFeedProductsContentModalCreate.inputs.nombre.label')"
          :message="$t('mFeedProductsContentModalCreate.inputs.nombre.message')"
          :messageError="messageErrorNombre"
          name="nombre"
          type="text"
          @blur="$v.producto.producto.nombre.$touch()"
        />
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mFeedProductsContentModalCreate.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeFeedProductsContentModalCreate',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mFeedProductsContentModalCreate.buttonPrimary'),
        class: 'a-button-products-primary',
        sending: false,
        type: 'submit'
      },

      producto: {
        academia: {
          id: ''
        },

        producto: {
          nombre: ''
        }
      }
    }
  },

  validations: {
    producto: {
      producto: {
        nombre: {
          maxLength: maxLength(120),
          minLength: minLength(5),
          required
        }
      }
    }
  },

  computed: {
    messageErrorNombre () {
      return this.$validation.getValidationMessage('mFeedProductsContentModalCreate', this.$v.producto.producto.nombre, 'producto', 'nombre')
    }
  },

  created () {
    this.producto.academia.id = this.$store.getters.getAcademyData.id
  },

  methods: {
    createProducto () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('producto', 'createProducto', this.producto)
          .then(response => {
            this.$modal.closeModal()
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mFeedProductsContentModalCreate', 'createProducto', 'success')
            this.$router.push(`/${this.$t('rPaths.product')}/${response.data.id}/${this.$t('mEditionMenu.product.card.subject')}`)
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mFeedProductsContentModalCreate', 'createProducto', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
